app.controller("StudentsIndexController", ["$scope", "$q", "StSubject", "StaticData", "Students", "ProgramService", "$uibModal", "ConfirmModal", "$stateParams", "$state", "usSpinnerService", "toastr",
    function ($scope, $q, StSubject, StaticData, Students, ProgramService, $uibModal, ConfirmModal, $stateParams, $state, usSpinnerService, toastr) {
        $scope.students = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.statesMap = {};
        $scope.levelsMap = {};
        $scope.subjectsMap = {};
        $scope.query = $stateParams.query;
        $scope.level = $stateParams.level;
        $scope.semester = 'სემესტრი';
        $scope.gender = $stateParams.gender;
        $scope.faculty = $stateParams.faculty;
        $scope.subject = $stateParams.subject;
        $scope.sortType = $stateParams.sortType || 'by_name';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.programs = [];
        $scope.selectedStates = [];
        $scope.selectedSemesters = [];
        $scope.lecturerProfile = $state.current.name === 'lecturer.students';
        $scope.lastSeason = $stateParams.lastSeason;
        var now = new Date();
        $scope.years = _.range(2017, now.getFullYear() + 1);

        function fillFilterFields() {
            if ($stateParams.program) {
                ProgramService.fetchList($stateParams.program).then(function (programs) {
                    $scope.programs = programs;
                });
            }
            if ($stateParams.state) {
                var state = $stateParams.state;
                state = typeof state === 'string' ? [state] : state;
                $scope.selectedStates = $scope.states.filter(function (st) {
                    return state.indexOf(st._id) > -1
                });
            }

            if ($stateParams.semester) {
                var semester = $stateParams.semester;
                semester = typeof semester === 'string' ? [semester] : semester;
                $scope.selectedSemesters = semester;
            }
        }


        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $q.all([
            StaticData.getItemsByKey("sort_types"),
            StaticData.getItemsByKey("faculties"),
            StaticData.getItemsByKey("levels"),
            StaticData.getItemsByKey("states"),
            StaticData.getItemsByKey("gender"),
            StaticData.getItemsByKey("teacher_program_subjects")
        ]).then(function (results) {
            var sortTypes = results[0];
            var faculties = results[1];
            var levels = results[2];
            var states = results[3];
            var genders = results[4];
            var subjects = results[5];

            $scope.sortTypes = sortTypes;
            $scope.sortTypesMap = _.keyBy($scope.sortTypes, '_id');

            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');

            $scope.levels = [{name: "საფეხური"}].concat(levels);
            $scope.levelsMap = _.keyBy($scope.levels, '_id');

            $scope.states = [{name: "სტატუსი"}].concat(states);
            $scope.statesMap = _.keyBy($scope.states, '_id');

            $scope.subjects = [{name: "საგანი"}].concat(subjects);
            $scope.subjectsMap = _.keyBy($scope.subjects, '_id');

            $scope.genders = [{name: "სქესი"}].concat(genders);

            fillFilterFields();
        });

        StaticData.getItemsByKey("subject_seasons").then(function (seasons) {
            $scope.seasons = [].concat(seasons);
            $scope.seasonsMap = _.keyBy($scope.seasons, '_id');

            $scope.filterSeasons = [];
            $scope.years.forEach(function (year) {
                $scope.seasons.forEach(function (season) {
                    $scope.filterSeasons.push({
                        _id: year + '-' + season._id,
                        name: year + ' ' + season.name
                    })
                })
            })
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                subject: $scope.subject,
                state: $scope.selectedStates.length ? $scope.selectedStates.map(function (p) {
                    return p._id;
                }) : undefined,
                gender: $scope.gender,
                lastSeason: $scope.lastSeason,
                sortType: $scope.sortType,
                program: $scope.programs.length ? $scope.programs.map(function (p) {
                    return p._id;
                }) : undefined,
                semester: $scope.selectedSemesters.length ? $scope.selectedSemesters : undefined,
            });
        };

        $scope.export = function () {
            // usSpinnerService.spin("root");
            Students.exportList({
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                subject: $stateParams.subject,
                state: $stateParams.state,
                sortType: $scope.sortType,
                program: $stateParams.program,
                semester: $stateParams.semester,
                lastSeason: $stateParams.lastSeason,
            })
            //     .then(function (data) {
            //     usSpinnerService.stop("root");
            //     window.open(data)
            // })
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            let key = $scope.lecturerProfile ? 'listForHead' : 'list';
            Students[key]({
                page: page,
                limit: $scope.itemsPerPage,
                query: $stateParams.query,
                faculty: $stateParams.faculty,
                level: $stateParams.level,
                subject: $stateParams.subject,
                state: $stateParams.state,
                sortType: $scope.sortType,
                program: $stateParams.program,
                semester: $stateParams.semester,
                gender: $scope.gender,
                lastSeason: $scope.lastSeason
            }).then(function (data) {
                var studentList = data.docs
                for (var i in studentList) {
                    if (!studentList[i].user.photo && studentList[i].user.gender == 'male') studentList[i].user.defaultPhoto = "img/male.jpg";
                    if (!studentList[i].user.photo && studentList[i].user.gender == 'female') studentList[i].user.defaultPhoto = "img/female.jpg";
                    else if (!studentList[i].user.photo && !studentList[i].user.gender) studentList[i].user.defaultPhoto = "img/no_image.jpg";
                }
                $scope.students = studentList;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.send = function () {
            Students.sendNotification().then(function (data) {})
        };

        $scope.studentInfo = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            window.open('student/register/form/' + student._id);
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddStudentController",
                templateUrl: _pb + 'admin/students/add-student.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.finances = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.studentPayments", {studentId: student._id, student: student});
        };
                $scope.finances = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.studentPayments", {studentId: student._id, student: student});
        };
        $scope.statesHistory = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "StudentStatesController",
                templateUrl: _pb + 'admin/students/states-history.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.changeState = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "StudentStateChangeController",
                templateUrl: _pb + 'admin/students/state-change.html',
                size: "md",
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.edit = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditStudentController",
                templateUrl: _pb + 'admin/students/edit-student.html',
                size: "md",
                resolve: {
                    student: function () {
                        return student;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };

        $scope.remove = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "სტუდენტის პროფილის წაშლა",
                message: "გსურთ პროფილის - " + student.user.firstName + " " + student.user.lastName + "ს წაშლა?"
            }).result.then(function () {
                Students.remove(student).then(
                    function (result) {
                        toastr.success('', 'სტუდენტის პროფილი წაიშალა სიიდან');
                        loadPage($scope.currentPage);
                    });
            });
        };

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            let key = $scope.lecturerProfile ? 'listForHead' : 'list';
            var params = {};
            params.query = name;
            return ProgramService[key](params).then(function (data) {
                return data.docs;
            });
        };

        $scope.showDetails = function (student) {
            $state.go("admin.studentCard", {studentId: student._id, student: student});
        };

        $scope.addProgramToFilter = function () {
            if ($scope.programs.indexOf($scope.program) > -1) return;
            $scope.programs.push($scope.program);
            $scope.program = null;
        };

        $scope.addStateToFilter = function () {
            if ($scope.selectedStates.map(function(s){return s._id}).indexOf($scope.state) > -1) return;
            $scope.selectedStates.push($scope.states.find(function (s) {
                return s._id === $scope.state
            }));
            $scope.state = $scope.states[0]._id;
        };

        $scope.addSemesterToFilter = function () {
            if ($scope.selectedSemesters.indexOf($scope.semester) > -1) return;
            $scope.selectedSemesters.push($scope.semester);
            $scope.semester = $scope.semesters[0];
        };

        $scope.removeState = function (st) {
            $scope.selectedStates = $scope.selectedStates.filter(function (p) {
                return p._id !== st._id
            });
            $scope.applyFilter();
        };

        $scope.removeProgram = function (pr) {
            $scope.programs = $scope.programs.filter(function (p) {
                return p._id !== pr._id
            });
            $scope.applyFilter();
        };
        $scope.removeSemester = function (pr) {
            $scope.selectedSemesters = $scope.selectedSemesters.filter(function (p) {
                return p !== pr
            });
            $scope.applyFilter();
        }
        $scope.copyMail = function (student, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            navigator.clipboard.writeText(student.user.email);

            for(let selected in $scope.students){
                $scope.students[selected].checked = false;
            }
            student.checked = true;
        };
    }
]);
